/* Keep editorial CTAs on the existing option selector and purchase form. */
(function () {
  'use strict';
  if (window.sidizPdpCtaReady) return;
  window.sidizPdpCtaReady = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-sidiz-return-to-options]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || destination.hash !== '#sidiz-pdp-head') return;

    var head = document.getElementById('sidiz-pdp-head');
    if (!head) return;
    var colourOptions = Array.from(head.querySelectorAll('[data-option="color"] input[data-option-position]:not(:disabled)'));
    var allOptions = Array.from(head.querySelectorAll('input[data-option-position]:not(:disabled)'));
    var candidates = colourOptions.filter(function (input) { return input.checked; })
      .concat(colourOptions, allOptions.filter(function (input) { return input.checked; }), allOptions);
    var option = candidates.find(function (input) {
      return input.getClientRects().length && window.getComputedStyle(input).visibility !== 'hidden' &&
        input.labels && input.labels[0] && input.labels[0].getClientRects().length;
    });
    var label = option && option.labels && option.labels[0];
    if (!option || !label || !label.getClientRects().length) return;

    event.preventDefault();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    label.scrollIntoView({ block: 'center', behavior: reducedMotion ? 'instant' : 'smooth' });
    option.focus({ preventScroll: true });
  });
})();
